import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { audioContext } from '../../../webAudio/audioContext';
import { lastLoopStart } from '../lastLoopStart';
import { PianoRollSvgLayer } from './PianoRollSvgLayer';

const mapStateToChordProgressProps = ({
   activeInterface: {
      referencePlaying,
      userPlaying,
      compareAnswer,
      tempo,
      referenceTempo,
      beatCount,
   },
}) => ({
   playing: userPlaying || (compareAnswer && referencePlaying),
   beatDuration: 60 / (referencePlaying ? referenceTempo : tempo),
   beatCount,
});

const PianoRollCursor = connect(mapStateToChordProgressProps)(
   ({
      playing,
      beatDuration,
      beatCount,
      lowNote,
      highNote,
      noteHeight,
      partsPerBeat,
      partWidth,
   }) => {
      const [progress, setProgress] = useState(null);
      const gridHeight = (highNote - lowNote + 1) * noteHeight;
      const gridWidth = beatCount * partsPerBeat * partWidth;

      useEffect(() => {
         let shouldAnimate = true;
         let nextFrameId;
         const animate = () => {
            const now = audioContext.currentTime;
            const loopStarted =
               now >= lastLoopStart.currentScheduledTime
                  ? lastLoopStart.currentScheduledTime
                  : lastLoopStart.previousScheduledTime;

            const newProgress =
               ((now - loopStarted) / (beatDuration * beatCount)) * gridWidth;

            if (loopStarted != null) {
               setProgress(newProgress);
            } else {
               setProgress(null);
            }

            if (playing && shouldAnimate) {
               nextFrameId = requestAnimationFrame(animate);
            }
         };
         if (playing) {
            animate();
         } else {
            setProgress(null);
         }
         return () => {
            cancelAnimationFrame(nextFrameId);
            shouldAnimate = false;
         };
      }, [playing, beatDuration, beatCount]);

      return (
         <PianoRollSvgLayer
            width={gridWidth}
            height={gridHeight}
            className="piano-roll-cursor-svg"
         >
            <line
               className="piano-roll-cursor"
               x1={progress}
               x2={progress}
               y1={0}
               y2={gridHeight}
            />
         </PianoRollSvgLayer>
      );
   }
);

export { PianoRollCursor };
